import { getFullName } from "../../../../utils/shared";
export const convertMentionsToIds = (text, users) => {
  const handleMap = new Map();
  for (const u of users) {
    const fullName = getFullName(u).toLowerCase();
    if (fullName) handleMap.set(fullName, u.id);
  }
  const pattern = [...handleMap.keys()]
    .sort((a, b) => b.length - a.length)
    .map((name) => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");

  return text.replace(new RegExp(`@(${pattern})`, "gi"), (_, name) => {
    const id = handleMap.get(name.toLowerCase());
    return id ? `<@${id}>` : `@${name}`;
  });
};
